import { createAction } from '@reduxjs/toolkit';
import { IFloorType } from '../../../share/types/ark1.0/floorType';
/* eslint-disable no-console */
// eslint-disable-next-line import/prefer-default-export
export const loadProjectAction = createAction('footPrint/loadProjectAction', (loadedFile: IFloorType []) => {
  try {
    return {
      payload: loadedFile.map((file: IFloorType) => ({
        ...file,
        undoHistory: [],
        unitLayoutFlag: {
          editable: false,
          id: null,
        },
      })),
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error, 'Possible file format error');
    return {
      payload: {},
    };
  }
});
